import moment from 'moment';
import React from 'react';
import Form from 'react-bootstrap/esm/Form';
import { useDispatch, useSelector } from 'react-redux';
import { IReducer } from '../../../../../../../../redux/configureStore';
import { setInitialDateOption } from '../../../../../../../../redux/fetchActions/legadoPage/outstandingDebitsApp';
import Wrapper from '../../../../../../../../shared/components/Wrapper';

function SetInitialDate() {
  const dispatch = useDispatch();
  const outstandigDebitsFilterState = useSelector(
    (reducer: IReducer) => reducer.outstandigDebitsFilter
  );

  function setDate(event: React.FormEvent<any>) {
    const { value } = event.currentTarget;
    dispatch(setInitialDateOption(value));
  }

  return (
    <Wrapper.Default flexDirection="row" isActive>
      <span>Início:</span>
      <Form.Control
        type="date"
        style={{ width: '10.5rem', margin: '0 0.5rem 0 0.25rem' }}
        value={moment(outstandigDebitsFilterState.initialDate).format(
          'YYYY-MM-DD'
        )}
        onChange={(event) => setDate(event)}
      />
    </Wrapper.Default>
  );
}

export default SetInitialDate;
